import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Avatar,
  Box,
  Rating,
  IconButton,
  TextField,
  Button,
  Card,
  CardMedia,
  CardContent,
  useTheme,
  useMediaQuery,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
import Carousel from "react-material-ui-carousel";
import {
  Phone,
  Email,
  Telegram,
  Whatsapp,
  Star,
  Comment,
  People,
  ExpandMore, WhatsApp,
} from "@mui/icons-material";
import { api_Routes } from "../../api_Routes";
import { Helper } from "../../tools/Helper";
import { useNavigate, useParams } from "react-router-dom/dist";
import { enqueueSnackbar } from "notistack";

const ResellerProfile = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [newReview, setNewReview] = useState({
    rating: 0,
    comment: "",
    subject: "",
  });
  const [isLoadingRating, setisloadingreting] = useState(false);
  const [showAllCustomers, setShowAllCustomers] = useState(false);
  const [reseller, setReseller] = useState(null);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const { id } = useParams();

  // Handle review submission
  const handleSubmitReview = async () => {
    setisloadingreting(true);
    const formData = new FormData();
    formData.append("rate", newReview.rating);
    formData.append("description", newReview.comment);
    formData.append("subject", newReview.subject);
    formData.append("reseller_id", id);
    const { response, message } = await Helper.Post({
      url: api_Routes.Reseller.Review,
      data: formData,
      hasToken: true,
    });
    if (response) {
      setisloadingreting(false);
      getReseller();
      setNewReview({ rating: "", subject: "", comment: "" });
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
    setisloadingreting(false);
    console.log("Submitting review:", newReview);
  };
  const getReseller = async () => {
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Header.getReseller}/${id}`,
      hasToken: true,
    });
    if (response) {
      setReseller(response.data);
    }
  };
  useEffect(() => {
    if (shouldRefresh) {
      setShouldRefresh(false);
    }
    getReseller();
  }, [id, shouldRefresh]);

  if (!reseller) return <div>Loading...</div>;
  return (
    <Box sx={{ p: 3, maxWidth: 1200, margin: "0 auto" }}>
      {/* Profile Section */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        {/* Photo Column */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: 0,
              paddingBottom: "100%",
              borderRadius: "50%",
              overflow: "hidden",
              bgcolor: "grey.200",
              boxShadow: 3,
            }}
          >
            {reseller.photo ? (
              <img
                src={reseller.url}
                alt={reseller?.name}
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Avatar
                sx={{
                  width: "100%",
                  height: "100%",
                  fontSize: "3rem",
                  bgcolor: "primary.main",
                }}
              >
                {reseller.name[0]}
              </Avatar>
            )}
          </Box>
        </Grid>

        {/* Details Column */}
        <Grid item xs={12} md={8}>
          {/* Name and Rating */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 700 }}>
              {reseller.name}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Rating
                value={reseller.rating}
                readOnly
                precision={0.5}
                size="large"
                sx={{ mr: 1 }}
              />
              <Typography variant="h6" color="text.secondary">
                ({reseller.reviews?.length || 0} reviews)
              </Typography>
            </Box>
          </Box>

          {/* Contact Details */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                <Phone sx={{ mr: 2, color: "primary.main", fontSize: 28 }} />
                <Typography
                    variant="body1"
                    onClick={() => window.open(`tel:${reseller.phone}`)}
                    sx={{
                      cursor: reseller.phone ? 'pointer' : 'default',
                      '&:hover': {
                        textDecoration: reseller.phone ? 'underline' : 'none',
                        color: reseller.phone ? 'primary.main' : 'inherit'
                      }
                    }}
                >
                  {reseller.phone || "Not provided"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                <Email sx={{ mr: 2, color: "primary.main", fontSize: 28 }} />
                <Typography
                    variant="body1"
                    onClick={() => window.open(`mailto:${reseller.email}`)}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline',
                        color: 'primary.main'
                      }
                    }}
                >
                  {reseller.email}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                <Telegram sx={{ mr: 2, color: "primary.main", fontSize: 28 }} />
                <Typography
                    variant="body1"
                    onClick={() => reseller.telegram && window.open(`https://t.me/${reseller.telegram.replace('@', '')}`, '_blank')}
                    sx={{
                      cursor: reseller.telegram ? 'pointer' : 'default',
                      '&:hover': {
                        textDecoration: reseller.telegram ? 'underline' : 'none',
                        color: reseller.telegram ? 'primary.main' : 'inherit'
                      }
                    }}
                >
                  {reseller.telegram || "Not provided"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                <WhatsApp sx={{ mr: 2, color: "primary.main", fontSize: 28 }} />
                <Typography
                    variant="body1"
                    onClick={() => reseller.whatsapp && window.open(`https://wa.me/${reseller.whatsapp.replace(/\D/g, '')}`, '_blank')}
                    sx={{
                      cursor: reseller.whatsapp ? 'pointer' : 'default',
                      '&:hover': {
                        textDecoration: reseller.whatsapp ? 'underline' : 'none',
                        color: reseller.whatsapp ? 'primary.main' : 'inherit'
                      }
                    }}
                >
                  {reseller.whatsapp || "Not provided"}
                </Typography>
              </Box>
            </Grid>

            {/* Customers */}
            <Grid item xs={12} md={6}>
              <Card sx={{ p: 2, bgcolor: "background.paper" }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <People sx={{ mr: 1, color: "primary.main" }} />
                  <Typography variant="h6">Customers</Typography>
                </Box>
                <List dense>
                  {reseller.panels
                    ?.slice(0, showAllCustomers ? undefined : 3)
                    .map((customer, index) => (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar src={customer?.logo}>
                            {customer?.smmpanel_name ? customer?.smmpanel_name[0] : 'p'}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={customer?.user}
                          secondary={customer?.smmpanel_name}
                        />
                      </ListItem>
                    ))}
                </List>
                {reseller.panels?.length > 3 && (
                  <Button
                    size="small"
                    onClick={() => setShowAllCustomers(!showAllCustomers)}
                    endIcon={<ExpandMore />}
                  >
                    {showAllCustomers
                      ? "Show less"
                      : `Show all ${reseller.panels.length}`}
                  </Button>
                )}
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Description Section */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          About Us
        </Typography>
        <Box
          sx={{
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
            p: 3,
            minHeight: 200,
            bgcolor: "background.paper",
          }}
        >
          <div
              dangerouslySetInnerHTML={{ __html: reseller.description }}
              style={{
                maxWidth: '100%',
                overflow: 'hidden',
                wordWrap: 'break-word'
              }}
          />
        </Box>
      </Box>

      {/* Ads Carousel */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Our Services
        </Typography>
        <Carousel
          animation="slide"
          navButtonsAlwaysVisible={!isMobile}
          indicators={!isMobile}
          height={400}
          sx={{ borderRadius: 2, overflow: "hidden" }}
        >
          {reseller.ads.map((ad, index) => (
            <Card
              key={index}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`resellerAd/${ad.id}`);
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: 400,
                  overflow: "hidden",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <CardMedia
                  component="img"
                  image={ad.url || "/placeholder-ad.jpg"}
                  alt={ad.name}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    p: 2,
                  }}
                />
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {ad.name}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Carousel>
      </Box>

      {/* Reviews Section */}
      <Box>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Customer Reviews ({reseller.reviews?.length || 0})
        </Typography>

        {/* Add Review Form */}
        <Card sx={{ mb: 4, p: 3, bgcolor: "background.paper" }}>
          <Typography variant="h6" gutterBottom>
            Write a Review
          </Typography>
          <TextField
            fullWidth
            label="Review Title"
            value={newReview.subject}
            onChange={(e) =>
              setNewReview({ ...newReview, subject: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          <Box sx={{ mb: 2 }}>
            <Typography component="legend">Your Rating</Typography>
            <Rating
              value={newReview.rating}
              onChange={(_, value) =>
                setNewReview({ ...newReview, rating: value })
              }
              size="large"
              sx={{ mt: 1 }}
            />
          </Box>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Your Review"
            value={newReview.comment}
            onChange={(e) =>
              setNewReview({ ...newReview, comment: e.target.value })
            }
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            size="large"
            startIcon={<Comment />}
            onClick={handleSubmitReview}
          >
            {isLoadingRating ? "Submitting..." : "Submit your review"}
          </Button>
        </Card>

        {/* Existing Reviews */}
        {reseller.reviews?.map((review, index) => (
          <Card key={index} sx={{ mb: 2, p: 3, bgcolor: "background.paper" }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Avatar sx={{ mr: 2, width: 56, height: 56 }}>
                {review.customer?.name[0]}
              </Avatar>
              <Box>
                <Typography variant="h6">{review.customer?.name}</Typography>
                <Rating
                  value={review.rate}
                  readOnly
                  size="medium"
                  sx={{ mt: 0.5 }}
                />
              </Box>
            </Box>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
              {review.subject}
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              {review.description}
            </Typography>
            <Divider sx={{ mt: 2 }} />
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ResellerProfile;
